import CeDocumentNameEditor from './CeDocumentNameEditor';

export default CeDocumentNameEditor;
